import { POSTHOG_FEATURES } from "../constants/feature-flags"
import usePostHogFeatureFlags from "./posthog-feaures"

export default function useAdForgeAccess() {
  const isFeatureFlagEnabled = usePostHogFeatureFlags(
    POSTHOG_FEATURES.AD_FORGE_ENABLED,
  )

  return { hasAccess: isFeatureFlagEnabled }
}
